import busRelationshipCodes from './busRelationshipCodes.json';
import envProps from './envProps.json';
import errorResponse from './errorResponse.json';
import phoneTypeCodes from './phoneTypeCodes.json';
import securityQuestions from './securityQuestions.json';
import validatePin from './validatePin.json';
import validateProfile from './validateProfile.json';

const envPropsData = () => envProps;

const validatePinData = () => validatePin;

const phoneTypeCodesData = () => phoneTypeCodes;

const busRelationshipCodesData = () => busRelationshipCodes;

const securityQuestionsData = () => securityQuestions;

const validateProfileData = () => validateProfile;

const errorResponseData = () => errorResponse;

export {
    envPropsData,
    validatePinData,
    phoneTypeCodesData,
    busRelationshipCodesData,
    securityQuestionsData,
    validateProfileData,
    errorResponseData
};
